import { Text } from '@foss/legion-ui'
import { CodeBlock } from '../content/CodeBlock'
import prose from '../content/Prose.module.css'

const MAPPINGS: [string, string, string][] = [
  ['variant="contained"', 'variant="primary"', 'The default; accent fill.'],
  ['variant="outlined"', 'variant="secondary"', 'Glass fill plus border.'],
  ['variant="text"', 'variant="tertiary"', 'No fill, no border.'],
  ['color="error"', 'tone="danger"', 'error → danger throughout.'],
  ['color="primary"', '(drop)', 'Primary is the default.'],
  ['color="textSecondary"', 'tone="muted"', ''],
  ['size="small"', 'size="sm"', 'Default is md; lg exists where meaningful.'],
  ['classes / makeStyles', 'CSS Module', 'Read --legion-* tokens directly.'],
  ['ThemeProvider', 'LegionProvider', 'createMuiTheme has no equivalent.'],
  ['useTheme()', 'useTheme()', 'Returns CSS strings, not a palette object.'],
]

export function Migrating() {
  return (
    <div className={prose.prose} data-testid="migrating-page">
      <section className={prose.section}>
        <Text>
          legion-ui is a 1:1 replacement for the Material-UI v4 surface the
          Navidrome fork actually imports — not for all of MUI. The full
          prop-level mapping, component by component, lives in{' '}
          <code>docs/migration.md</code> in the legion-ui repository; it is
          generated as each phase lands and is the authority. What follows is
          the shape of it.
        </Text>
      </section>

      <section className={prose.section}>
        <Text variant="heading" as="h2">
          Conventions that apply everywhere
        </Text>
        <div className={prose.tableWrap}>
          <table className={prose.table}>
            <thead>
              <tr>
                <th>Material-UI</th>
                <th>legion-ui</th>
                <th>Notes</th>
              </tr>
            </thead>
            <tbody>
              {MAPPINGS.map(([mui, legion, note]) => (
                <tr key={mui}>
                  <td>
                    <code>{mui}</code>
                  </td>
                  <td>
                    <code>{legion}</code>
                  </td>
                  <td>{note}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <Text>
          <code>className</code> merges rather than being replaced, and native
          attributes — <code>id</code>, <code>data-*</code>, <code>aria-*</code>
          , <code>onClick</code> — spread onto the root element, so anything you
          did by reaching for the DOM still works.
        </Text>
      </section>

      <section className={prose.section}>
        <Text variant="heading" as="h2">
          What is deliberately missing
        </Text>
        <Text>
          There is no <code>makeStyles</code>, no <code>withStyles</code>, no{' '}
          <code>classes</code> prop, and no style runtime of any kind. legion-ui
          ships zero runtime dependencies; styling a consumer component means a
          CSS Module reading <code>--legion-*</code> tokens.
        </Text>
        <CodeBlock label="Before / after">{`// MUI v4
const useStyles = makeStyles((theme) => ({
  row: { gap: theme.spacing(2), color: theme.palette.text.secondary },
}))

// legion-ui — Row.module.css
.row {
  gap: var(--legion-space-2);
  color: var(--legion-fg-muted);
}`}</CodeBlock>
      </section>
    </div>
  )
}
